import styled from 'styled-components';

import { media } from 'style-utils';

const Container = styled.div`

  padding: 0 16px;
  max-width: 100%;
  margin: 0 auto;

  ${media.ipadProLandscape`
    width: 100% !important;
  `}

  ${media.desktop`
    width: 1024px;
  `}

  ${media.screen`
    width: 1200px;
    padding: 0 16px;
    padding-left:0px;
  `}

  width: ${props => props.wide && '95% !important'}; //TODO: Retest this change.
`;

export default Container;



// WEBPACK FOOTER //
// ./src/components/layouts/Container.js